import { Box, Paper, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import PlagiarismOutlinedIcon from '@mui/icons-material/PlagiarismOutlined';

import { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { acGetAllCreditPolicies } from '../../store/actions'
import { ROUTES } from '../../store/constants'
import { PanelBox, PrimaryButton, Snackbar } from '../default'
import { CreditPoliciesTable } from '../tables'

const CreditPoliciesPanel = () => {
    const location = useLocation()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        dispatch(acGetAllCreditPolicies())
            .catch(error => console.error(error))
        // eslint-disable-next-line
    }, [])

    const successAlert = location.state?.successAlert
    const [snackbarData, setSnackbarData] = useState(
        successAlert ?? { open: false, severity: 'success', message: '' }
    )

    const creditPolicies = useSelector(state => state.creditPolicies?.allCreditPolicies)

    const handleSnackbarClose = (_, reason) => {
        if (reason === 'clickaway') return
        setSnackbarData({ ...snackbarData, open: false })
    }

    const handleCreate = () => {
        navigate(ROUTES.CREDIT_POLICIES_CREATE)
    }

    return (
        <PanelBox title='Políticas de Crédito'>

            {creditPolicies && creditPolicies.length === 0 ? (
                <Paper elevation={0} sx={{ padding: 3 }}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                        Criar Políticas de Crédito
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 3 }}>
                        Defina regras e condições para alterar o limite de crédito
                    </Typography>

                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 2
                        }}
                    >
                        <PlagiarismOutlinedIcon sx={{ fontSize: 40 }} color="primary" />

                        <Typography variant="body2" sx={{ textAlign: 'center' }}>
                            Não há Políticas de Crédito registradas. Você pode criar uma nova política clicando no botão abaixo.
                        </Typography>

                        <PrimaryButton
                            label="Criar Política"
                            Icon={AddIcon}
                            onClick={handleCreate}
                        />
                    </Box>
                </Paper>
            ) : (
                <CreditPoliciesTable />
            )}

            <Snackbar
                open={snackbarData.open}
                onClose={handleSnackbarClose}
                message={snackbarData.message}
                severity={snackbarData.severity}
            />
        </PanelBox>
    )
}

export default CreditPoliciesPanel
